import React from "react";
import { ReactComponent as IconBlind } from "./icons/blind.svg";
import { ReactComponent as IconCalendar } from "./icons/calendar.svg";
import { ReactComponent as IconCard } from "./icons/card.svg";
import { ReactComponent as IconCardBlocked } from "./icons/card-blocked.svg";
import { ReactComponent as IconChat } from "./icons/chat.svg";
import { ReactComponent as IconChevronRight } from "./icons/chevron-right.svg";
import { ReactComponent as IconChevronBottom } from "./icons/chevron-bottom.svg";
import { ReactComponent as IconHome } from "./icons/home.svg";
import { ReactComponent as IconLockCard } from "./icons/lock-card.svg";
import { ReactComponent as IconMoney } from "./icons/money.svg";
import { ReactComponent as IconPaper } from "./icons/paper.svg";
import { ReactComponent as IconPaperOrange } from "./icons/paper-orange.svg";
import { ReactComponent as IconPassword } from "./icons/password.svg";
import { ReactComponent as IconPasswordProfile } from "./icons/password-profile.svg";
import { ReactComponent as IconQuestion } from "./icons/question.svg";
import { ReactComponent as IconTick } from "./icons/tick.svg";
import { ReactComponent as IconTransfer } from "./icons/transfer.svg";
import { ReactComponent as IconTransition } from "./icons/transition.svg";
import { ReactComponent as IconUser } from "./icons/user.svg";
import { ReactComponent as Warning } from "./icons/warning.svg";
import { ReactComponent as Seguranca } from "./icons/Seguranca.svg";
import { ReactComponent as Consulta } from "./icons/Consulta.svg";
import { ReactComponent as ConsultGrey } from "./icons/consult-grey.svg";

// PNG
import cardBackgroundTeuCard from './images/cardview/cardBackground-teucard.png';
import creditCardLogoWhite from './images/cardview/white-card.png';
import creditCardLogoBlue from './images/cardview/blue-card.png';
import creditCardLogoRose from './images/cardview/rose-card.png';
import backspace from './images/backspace.png';
import pinpad from './images/Pinpad.png';
import sucesso from './images/sucesso.png'

// Movies
import gifPinPad from './movies/terminalPos.gif'

const icons = {
  eye: require("./icons/eye.png"),
  blind: <IconBlind />,
  calendar: <IconCalendar />,
  card: <IconCard />,
  cardBlocked: <IconCardBlocked />,
  chat: <IconChat />,
  chevronRight: <IconChevronRight />,
  chevronBottom: <IconChevronBottom />,
  home: <IconHome />,
  lockCard: <IconLockCard />,
  money: <IconMoney />,
  paper: <IconPaper />,
  paperOrange: <IconPaperOrange />,
  password: <IconPassword />,
  passwordProfile: <IconPasswordProfile />,
  question: <IconQuestion />,
  tick: <IconTick />,
  transfer: <IconTransfer />,
  transition: <IconTransition />,
  user: <IconUser />,
  warning: <Warning />,
  seguranca: <Seguranca />,
  consulta: <Consulta />,
  consultGrey: <ConsultGrey />,
};

const images = {
  logo: require("./images/logo.png"),
  search: require("./images/search.png"),
  avatar: require("./images/avatar.png"),
  warning: require("./images/warning.png"),
  visible: require("./images/visible.png"),
  invisible: require("./images/invisible.png"),
  arrowDown: require("./images/arrow-down.png"),
  cardBackground: require("./images/cardview/cardBackground.png"),
  opahLogoHorizontal: require("./images/opah-logo-horizontal.png"),
  creditCardLogoRose,
  creditCardLogoBlue,
  creditCardLogoWhite,
  cardBackgroundTeuCard,
  backspace,
  pinpad,
  sucesso,
};

const movies = {
  gifPinPad,
};

const assets = { icons, images, movies };

export default assets;
